import request from './request'

/** 素材库列表（后端 M4 开放；M3 可先通过任务详情获取素材） */
export function fetchMaterials(params = {}) {
  return request.get('/materials', { params })
}

/** 单图导出 PSD（单图层 + 可选透明底 PNG），产物自动登记为素材 */
export function exportPsd(id) {
  return request.post('/materials/exportPsd', null, { params: { id } })
}

/** 把生成结果加入素材库 */
export function addToLib(id) {
  return request.post('/materials/addToLib', null, { params: { id } })
}

/** 按条件打包下载素材（返回 zip blob；传 jobId 或 source/media/type/keyword） */
export function downloadMaterialsZip(params = {}) {
  return request.get('/materials/zip', { params, responseType: 'blob', timeout: 300000 })
}

/** 「改一改」重新生成的预计消耗积分（与后端实际扣费同一套算法，含模型分级单价） */
export function fetchRedoPoints(id) {
  return request.get('/materials/redoPoints', { params: { id } })
}

/** 批量删除素材（单个删除就是只传一个 id）；后端会同时清掉磁盘文件（若无其它记录引用） */
export function deleteMaterials(ids) {
  return request.post('/materials/delete', null, { params: { ids: (ids || []).join(',') } })
}
